/* eslint-disable no-redeclare */
// TODO: remove code above and fix issues in case changing this file
'use strict';

(function() {
	angular.module('onboarding.broker.contracts')
		.directive('cobContractSignaturesList', cobContractSignaturesList);

	cobContractSignaturesList.$inject = [
		'subjectObserverMessagesService', 'observerService', 'contractService', '$log', '$timeout', 'sessionService', '$state',
		'$stateParams'
	];

	var subjectObserverMessagesService,
		observerService,
		contractService,
		subjectMessages,
		observerMessages,
		rowCount,
		$log,
		$timeout,
		sessionService,
		$state,
		$stateParams,
		reloadAjax;

	function cobContractSignaturesList(_subjectObserverMessagesService_,
		_observerService_,
		_contractService_,
		_$log_,
		_$timeout_,
		_sessionService_,
		_state_,
		_$stateParams_) {
		subjectObserverMessagesService = _subjectObserverMessagesService_;
		observerService = _observerService_;
		contractService = _contractService_;
		rowCount = 100;
		$log = _$log_;
		$timeout = _$timeout_;
		sessionService = _sessionService_;
		$state = _state_;
		$stateParams = _$stateParams_;

		return {
			restrict: 'E',
			scope: {},
			replace: true,
			templateUrl: '/app/broker/contracts/contractSignaturesList.html',
			link: linkFunction
		};
	}

	function linkFunction(scope) {

		activate();

		function activate() {

			if (sessionService.isAuthorizedInternalAdmin() && !$stateParams.brokerId) {
				$state.go('brokersAdmin');

				return;
			}

			subjectMessages = subjectObserverMessagesService.getSubjectMessages();
			observerMessages = subjectObserverMessagesService.getObserverMessages();

			scope.$stateParams = $stateParams;
			scope.m = {
				errors: []
			};
			scope.signatures = [];
			scope.contractId = $stateParams['contractid'];
			scope.contract = {};
			scope.ajaxIsRunning = false;

			scope.currentRow = 0;
			scope.isSortDescending = true;
			scope.sortOrder = 'date';
			scope.filter = '';
			scope.filterType = 'sortName';
			scope.filterInputPlaceholder = 'e.g. Sample Company';
			scope.isFilter = false;
			scope.haveAllRows = false;
			scope.allChecked = false;
			scope.checkedCount = 0;
			scope.lastClicked = -1;


			scope.rejectSignatureHideConfirm = rejectSignatureHideConfirm;
			scope.rejectClicked = rejectClicked;
			scope.getSignatures = getSignatures;
			scope.rejectSignatures = rejectSignatures;
			scope.timezoneFilter = timezoneFilter;
			scope.hamburgerClicked = hamburgerClicked;
			scope.filterTypeChange = filterTypeChange;
			scope.filterInputKeyPress = filterInputKeyPress;
			scope.filterInputChange = filterInputChange;
			scope.searchClick = searchClick;
			scope.toggleChecked = toggleChecked;
			scope.exportSignatures = exportSignatures;
			scope.selectedSignatures = selectedSignatures;
			scope.exportSignaturesDisable = exportSignaturesDisable;
			scope.showRejectConfirmation = { showConfirmation: false };
			scope.sort = sort;
			scope.enableRejectButton = false;
			scope.rejectableCheckedCount = 0;
			scope.singleSigneeName = '';
			scope.statChoices = [];

			if (sessionService.isAuthorizedBrokerWrite()) {
				scope.statusChoices = [
					{ id: 0, name: 'Export Selected to CSV' },
					{ id: 1, name: 'Reject' }
				];
			} else {
				scope.statusChoices = [
					{ id: 0, name: 'Export Selected to CSV' }
				];
			}

			getSignatures(true);
			getDetails();
			registerEventHandlers();
			document.title = 'Contract Signatures';
		}

		function registerEventHandlers() {
			observerService.registerHandlers(scope,
				[
					{ message: observerMessages.COB_OBSERVER_SCROLL_MESSAGE, handler: getSignatures }
				]);
		}

		function rejectClicked() {
			scope.showRejectConfirmation.showConfirmation = true;

			var length = scope.signatures.length;
			if (scope.rejectableCheckedCount === 1) {
				for (var i = 0; i < length; i++) {
					if (scope.signatures[i].checked && scope.signatures[i].status.toLowerCase() === 'active') {
						scope.singleSigneeName = scope.signatures[i].signee;

						return;
					}
				}
			}
		}

		function hamburgerClicked() {
			switch (scope.selectedStatus) {
			case 0:
				if (scope.checkedCount > 0) {
					exportSignatures();
				}
				break;
			case 1:
				if (scope.rejectableCheckedCount > 0) {
					rejectClicked();
				}
				break;
			default:
			}

			scope.selectedStatus = null;
		}

		function filterTypeChange() {
			switch (scope.filterType) {
			case 'signatory':
				scope.filterInputPlaceholder = 'e.g. John Doe';
				break;
			case 'sortName':
				scope.filterInputPlaceholder = 'e.g. Sample Company';
				break;
			case 'title':
				scope.filterInputPlaceholder = 'e.g. Owner';
				break;
			}
		}

		function validateFilter() {
			if (scope.filter.length === 0) {
				return false;
			}

			return true;
		}

		function filterInputKeyPress(event) {
			var charCode = (event.which) ? event.which : event.keyCode;
			if (charCode === 13) { // on Enter
				searchClick();
				event.preventDefault();

				return;
			}
			switch (charCode) {
			case 8: //backspace
			case 35: //end
			case 36: //home
			case 37: //left arrow
			case 39: //right arrow
			case 46: //delete
				return;
			}
		}

		function filterInputChange() {
			switch (scope.filterType) {
			case 'signatory':
				scope.filter = scope.filter.substring(0, 100);
				break;
			case 'sortName':
				scope.filter = scope.filter.substring(0, 155);
				break;
			case 'title':
				scope.searchValue = scope.searchValue.substring(0, 100);
				break;
			}
		}

		function searchClick(clearSearch) {
			if (clearSearch) {
				scope.filter = '';
			}
			if (validateFilter() || clearSearch) {
				scope.currentRow = 0;
				scope.haveAllRows = false;
				scope.isFilter = (scope.filter.length > 0);
				$timeout(function () {
					if (scope.ajaxIsRunning) {
						reloadAjax = true;
					}
					getSignatures(true);
				}); // need to wait for $apply from date switch in validation
			}
		}

		function getSignatures(clearOld) {
			if (scope.ajaxIsRunning) {
				return;
			}

			if (scope.haveAllRows === false) {
				scope.ajaxIsRunning = true;
				setTimeout(function() {
					observerService.sendMessageToSubject(scope,
						subjectObserverMessagesService.getSubjectMessages().COB_SUBJECT_AJAX_WAITING);
				},
				1);

				contractService.getContractSignatures(scope.contractId,
					scope.currentRow,
					rowCount,
					scope.sortOrder,
					scope.isSortDescending,
					scope.filter,
					scope.filterType)
					.then(function(response) {
						var length = response.data.signatures.length;
						scope.currentRow += rowCount;
						if (clearOld) {
							scope.signatures = response.data.signatures;
							scope.allChecked = false;
							scope.checkedCount = 0;
							scope.rejectableCheckedCount = 0;
							scope.availableRows = response.data.availableRows;
						} else {
							for (var i = 0; i < length; i++) {
								response.data.signatures[i].checked = false;
								scope.signatures.push(response.data.signatures[i]);
							}
						}
						if (length < rowCount) {
							scope.haveAllRows = true;
						}
					})
					.catch(function(e) {
						console.log(e);
						// alert('Unable to retrieve carriers');
					})
					.finally(function() {
						scope.ajaxIsRunning = false;
						observerService
							.sendMessageToSubject(scope,
								subjectObserverMessagesService.getSubjectMessages().COB_SUBJECT_AJAX_DONE);
					});
			}

			return;
		}

		function rejectSignatures() {
			var rejectedSignatures = [];
			var length = scope.signatures.length;

			for (var i = 0; i < length; i++) {
				if (scope.signatures[i].checked && scope.signatures[i].status.toLowerCase() === 'active') {
					rejectedSignatures.push(scope.signatures[i].signatureId);
					scope.signatures[i].signee = 'REJECTED';
					scope.signatures[i].status = 'REJECTED';
					scope.signatures[i].title = '–';
				}
			}

			setTimeout(function () {
				observerService.sendMessageToSubject(scope, subjectObserverMessagesService.getSubjectMessages().COB_SUBJECT_AJAX_WAITING);
			}, 1);

			contractService.rejectSignatures(rejectedSignatures)
				.then(function() {
					scope.currentRow = 0;
					scope.haveAllRows = false;
					// Do not refresh list, model is updated.  UX wants to retain checkbox checked state
				})
				.catch(function(e) {
					console.log(e);
				}).finally(function () {
					observerService.sendMessageToSubject(scope, subjectObserverMessagesService.getSubjectMessages().COB_SUBJECT_AJAX_DONE);
				});

			scope.showRejectConfirmation.showConfirmation = false;

			rejectedSignatures = [];
			scope.rejectableCheckedCount = 0;
		}

		function rejectSignatureHideConfirm() {
			scope.showRejectConfirmation.showConfirmation = false;
		}

		function sort(sortBy) {

			if (sortBy === scope.sortOrder) {
				scope.isSortDescending = !scope.isSortDescending;
			} else {
				scope.sortOrder = sortBy;
				scope.isSortDescending = true;
			}

			scope.currentRow = 0;
			scope.haveAllRows = false;


			getSignatures(true);
		}

		function timezoneFilter(time) {
			var timeObj = new Date(time);
			if (timeObj.getTimezoneOffset() / 60 === 7)
				return 'PDT';
			else if (timeObj.getTimezoneOffset() / 60 === 8)
				return 'PST';
			else //should not happen but we do not want to give wrong data ever
				return 'UTC -' + (timeObj.getTimezoneOffset() / 60);
		}

		function toggleChecked(event, index) {
			if (scope.lastClicked > -1 && event.shiftKey) {
				angular.forEach(scope.signatures.slice(Math.min(scope.lastClicked, index),
					Math.max(scope.lastClicked, index) + 1),
				function(signature) {
					if (signature.checked) {
						scope.checkedCount--;
						if (signature.status.toLowerCase() === 'active') {
							scope.rejectableCheckedCount--;
						}
					}
					signature.checked = scope.signatures[scope.lastClicked].checked;

					if (scope.signatures[scope.lastClicked].checked) {
						scope.checkedCount++;
						if (signature.status.toLowerCase() === 'active') {
							scope.rejectableCheckedCount++;
						}
					}
				});
				document.getSelection().removeAllRanges();
			} else {
				var signature = scope.signatures[index];
				signature.checked = !signature.checked;
				if (signature.checked) {
					scope.checkedCount++;
					if (signature.status.toLowerCase() === 'active') {
						scope.rejectableCheckedCount++;
					}
				} else {
					scope.checkedCount--;
					if (signature.status.toLowerCase() === 'active') {
						scope.rejectableCheckedCount--;
					}
				}
			}
			scope.lastClicked = index;
			event.stopPropagation();
			event.preventDefault();
		}

		function getDetails() {
			setTimeout(function () {
				observerService.sendMessageToSubject(scope, subjectObserverMessagesService.getSubjectMessages().COB_SUBJECT_AJAX_WAITING);
			}, 1);

			contractService.getContractDetail(scope.contractId)
				.then(function(response) {
					scope.contract = response.data;
				})
				.catch(function(e) {
					console.log(e);
				}).finally(function () {
					observerService.sendMessageToSubject(scope, subjectObserverMessagesService.getSubjectMessages().COB_SUBJECT_AJAX_DONE);
				});

			return;
		}

		function exportSignaturesDisable() {
			if (scope.signatures.length === 0) {
				return true;
			}

			return false;
		}

		function exportSignatures() {
			if (scope.checkedCount > 0) {
				//export selected
				var exportedSignatures = [];
				var length = scope.signatures.length;

				for (var i = 0; i < length; i++) {
					if (scope.signatures[i].checked)
						exportedSignatures.push(scope.signatures[i].signatureId);
				}

				contractService.exportContractSignatures(scope.contractId, exportedSignatures)
					.then(downloadFile)
					.catch(function (e) {
						console.log(e);
					});
			} else if (scope.isFilter) {
				exportedSignatures = [];
				length = scope.signatures.length;

				for (var i = 0; i < length; i++) {
					exportedSignatures.push(scope.signatures[i].signatureId);
				}

				contractService.exportContractSignatures(scope.contractId, exportedSignatures)
					.then(downloadFile)
					.catch(function (e) {
						console.log(e);
					});
			} else {
				//export all
				contractService.exportAllContractSignatures(Number(scope.contractId))
					.then(function (response) {
						scope.showExportConfirmation = true;
						scope.exportConfirmationEmailAddress = response.data.emailAddress;
					})
					.catch(function (e) {
						console.log(e);
					});
			}
		}

		function selectedSignatures() {
			var signatures = '';
			angular.forEach(scope.signatures,
				function (signature) {
					if (signature.checked) {
						if (signatures !== '') {
							signatures = signatures + '&signatureIds=' + signature.signatureId;
						} else {
							signatures = 'signatureIds=' + signature.signatureId;
						}
					}
				});

			if (signatures.length) {
				scope.m.hasSelectedSignatures = true;
			} else {
				scope.m.hasSelectedSignatures = false;
			}

			return signatures;
		}

		function getDate() {
			var today = new Date();
			var returnVal = today.getFullYear().toString();

			if (today.getMonth() < 9) {
				returnVal += '0' + (today.getMonth() + 1);
			} else {
				returnVal += (today.getMonth() + 1);
			}

			if (today.getMonth() < 9) {
				returnVal += '0' + (today.getDate() + 1);
			} else {
				returnVal += (today.getDate() + 1);
			}

			return returnVal;
		}

		function downloadFile(response) {
			var blob = new Blob([response.data], { type: 'text/csv;charset=utf-8' });
			var fileName = scope.contract.contractName + '+Signatures+' + getDate() + '.csv';

			if (navigator.msSaveBlob) { // IE 10+
				navigator.msSaveBlob(blob, fileName);
			} else {
				var link = document.createElement('a');
				if (link.download !== undefined) { // feature detection
					// Browsers that support HTML5 download attribute
					var url = URL.createObjectURL(blob);
					link.setAttribute('href', url);
					link.setAttribute('download', fileName);
					link.style.visibility = 'hidden';
					document.body.appendChild(link);
					link.click();
					document.body.removeChild(link);
				} else { // safari sucks
					url = URL.createObjectURL(blob);
					link.setAttribute('href', url);
					link.setAttribute('download', fileName);
					link.style.visibility = 'hidden';
					document.body.appendChild(link);
					link.click();
					document.body.removeChild(link);
				}
			}
		}
	}
})();
